import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const AlertError20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_733)'>
      <path
        d='M7.5 6.43933L9.99995 8.93928L12.4999 6.43934L13.5605 7.5L11.0606 9.99994L13.5607 12.5L12.5 13.5607L9.99995 11.0606L7.49989 13.5607L6.43923 12.5L8.93929 9.99994L6.43934 7.49999L7.5 6.43933Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10 0.25C4.61522 0.25 0.25 4.61522 0.25 10C0.25 15.3848 4.61522 19.75 10 19.75C15.3848 19.75 19.75 15.3848 19.75 10C19.75 4.61522 15.3848 0.25 10 0.25ZM1.75 10C1.75 5.44365 5.44365 1.75 10 1.75C14.5563 1.75 18.25 5.44365 18.25 10C18.25 14.5563 14.5563 18.25 10 18.25C5.44365 18.25 1.75 14.5563 1.75 10Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_733'>
        <rect width='20' height='20' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

AlertError20.displayName = 'AlertError20';
export default AlertError20;
